import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "text-truncate pl-4" };
const _hoisted_2 = {
    key: 0,
    class: "text-info text-truncate d-block"
};
const _hoisted_3 = { class: "d-flex align-center" };
const _hoisted_4 = { class: "d-flex align-center flex-nowrap mb-2" };
const _hoisted_5 = { class: "text-info" };
const _hoisted_6 = {
    key: 0,
    class: "text-center text-truncate"
};
const _hoisted_7 = {
    key: 1,
    class: "skeleton-box rounded-md",
    style: { "height": "20px" }
};
const _hoisted_8 = {
    key: 1,
    class: "skeleton-box rounded-md",
    style: { "height": "40px", "min-width": "40px", "max-width": "40px" }
};
const _hoisted_9 = {
    key: 0,
    class: "text-center"
};
const _hoisted_10 = { class: "text-info mb-2" };
const _hoisted_11 = { class: "d-flex" };
const _hoisted_12 = { class: "text-info mb-2" };
import AppTransformHash from '@core/components/AppTransformHash.vue';
import AppTableRow from '@core/components/AppTableRow.vue';
import AppChip from '@core/components/AppChip.vue';
import AppAddressBlockie from '@core/components/AppAddressBlockie.vue';
import { useDisplay } from 'vuetify';
import BN from 'bignumber.js';
import { formatNumber } from '@core/helper/number-format-helper';
import { computed, reactive } from 'vue';
import { timeAgo, eth } from '@core/helper';
import TokenNftImg from '@module/tokens/components/token-nft/TokenNftImg.vue';
import Web3Utils from 'web3-utils';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TableRowNftTransfers',
    props: {
        isOverview: { type: Boolean },
        transfer: null,
        addressHash: null,
        nftMeta: null,
        metaIsLoading: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const { mdAndDown, smAndDown } = useDisplay();
        const state = reactive({
            showMoreDetails: false
        });
        const tokenMeta = computed(() => {
            return {
                type: props.transfer.transfer.type,
                contract: props.transfer.contract,
                id: Web3Utils.hexToNumberString(props.transfer.tokenId),
                meta: props.nftMeta
            };
        });
        const tokenName = computed(() => {
            return props.nftMeta && props.nftMeta.name
                ? props.nftMeta.name
                : props.transfer.tokenInfo.name
                    ? props.transfer.tokenInfo.name
                    : `Unknown-${props.transfer.transfer.type}`;
        });
        const totalTokens = computed(() => {
            if (props.transfer.value && props.transfer.value !== '0x0') {
                return formatNumber(new BN(props.transfer.value).toNumber());
            }
            return '1';
        });
        const TYPES = ['in', 'out', 'self'];
        const transferType = computed(() => {
            const from = props.transfer.transfer.from.toLowerCase();
            const to = props.transfer.transfer.to.toLowerCase();
            const addr = props.addressHash.toLowerCase();
            if (addr === from && addr === to) {
                return TYPES[2];
            }
            else if (addr === from) {
                return TYPES[1];
            }
            return TYPES[0];
        });
        const transferTypeAddress = computed(() => {
            switch (transferType.value) {
                case TYPES[0]:
                    return props.transfer.transfer.from;
                case TYPES[1]:
                    return props.transfer.transfer.to;
                default:
                    return props.addressHash;
            }
        });
        const toggleMoreDetails = () => {
            if (mdAndDown.value) {
                state.showMoreDetails = !state.showMoreDetails;
            }
        };
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_row = _resolveComponent("v-row");
            return (!_unref(smAndDown))
                ? (_openBlock(), _createBlock(AppTableRow, {
                    key: 0,
                    "row-align": "center"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                            cols: props.isOverview ? 4 : 3,
                            class: "d-flex align-center"
                        }, {
                            default: _withCtx(() => [
                                (!props.metaIsLoading)
                                    ? (_openBlock(), _createBlock(TokenNftImg, {
                                        key: 0,
                                        loading: props.metaIsLoading,
                                        nft: _unref(tokenMeta),
                                        height: "40",
                                        width: "40",
                                        class: "rounded-md"
                                    }, null, 8, ["loading", "nft"]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("p", _hoisted_1, [
                                    _createTextVNode(_toDisplayString(_unref(tokenName)) + " ", 1),
                                    (props.isOverview)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(timeAgo)(new Date(props.transfer.transfer.timestamp * 1e3), true)), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _: 1
                        }, 8, ["cols"]),
                        _createVNode(_component_v_col, {
                            cols: props.isOverview ? 2 : 1,
                            class: "text-info text-truncate"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(totalTokens)), 1)
                            ]),
                            _: 1
                        }, 8, ["cols"]),
                        _createVNode(_component_v_col, {
                            cols: props.isOverview ? 2 : 1
                        }, {
                            default: _withCtx(() => [
                                _createVNode(AppChip, {
                                    bg: _unref(transferType) === 'in' ? 'success' : 'warning',
                                    text: _unref(transferType) === 'in' ? _ctx.$t('common.from') : _ctx.$t('common.to')
                                }, null, 8, ["bg", "text"])
                            ]),
                            _: 1
                        }, 8, ["cols"]),
                        _createVNode(_component_v_col, {
                            cols: props.isOverview ? 4 : 3,
                            class: "text-secondary"
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(AppAddressBlockie, {
                                        address: _unref(transferTypeAddress) || '',
                                        size: 6,
                                        class: "mr-4"
                                    }, null, 8, ["address"]),
                                    _createVNode(AppTransformHash, {
                                        "is-blue": "",
                                        "is-short": "",
                                        hash: _unref(eth).toCheckSum(_unref(transferTypeAddress)),
                                        link: `/address/${_unref(transferTypeAddress)}`
                                    }, null, 8, ["hash", "link"])
                                ])
                            ]),
                            _: 1
                        }, 8, ["cols"]),
                        (!props.isOverview)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "2",
                                class: "text-secondary"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(AppTransformHash, {
                                        "is-blue": "",
                                        "is-short": "",
                                        hash: _unref(eth).toCheckSum(props.transfer.transfer.transactionHash),
                                        link: `/tx/${props.transfer.transfer.transactionHash}`
                                    }, null, 8, ["hash", "link"])
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (!props.isOverview)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 1,
                                cols: "2",
                                class: "text-info"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(timeAgo)(new Date(props.transfer.transfer.timestamp * 1e3))), 1)
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }))
                : (_openBlock(), _createBlock(AppTableRow, {
                    key: 1,
                    "row-align": "start",
                    "row-justify": "space-between",
                    onClick: toggleMoreDetails,
                    color: state.showMoreDetails ? 'lightGrey' : 'transparent'
                }, {
                    expandable: _withCtx(() => [
                        (state.showMoreDetails)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "12"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_row, { class: "mx-0 justify-space-between mb-2" }, {
                                        default: _withCtx(() => [
                                            (props.transfer.tokenInfo.name)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(props.transfer.tokenInfo.name), 1))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("p", null, _toDisplayString(_unref(totalTokens)) + " Copies", 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_component_v_row, { class: "ma-0 justify-space-between pb-5" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t('common.address')), 1),
                                                _createElementVNode("div", _hoisted_11, [
                                                    _createVNode(AppAddressBlockie, {
                                                        address: _unref(transferTypeAddress) || '',
                                                        size: 6,
                                                        class: "mr-2"
                                                    }, null, 8, ["address"]),
                                                    _createVNode(AppTransformHash, {
                                                        "is-blue": "",
                                                        "is-short": "",
                                                        hash: _unref(eth).toCheckSum(_unref(transferTypeAddress)),
                                                        link: `/address/${_unref(transferTypeAddress)}`
                                                    }, null, 8, ["hash", "link"])
                                                ])
                                            ]),
                                            _createElementVNode("div", null, [
                                                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('common.hash')), 1),
                                                _createVNode(AppTransformHash, {
                                                    "is-blue": "",
                                                    "is-short": "",
                                                    hash: _unref(eth).toCheckSum(props.transfer.transfer.transactionHash),
                                                    link: `/tx/${props.transfer.transfer.transactionHash}`
                                                }, null, 8, ["hash", "link"])
                                            ])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_component_v_col, { class: "flex-shrink-0" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["mobile-chip rounded-circle mr-2", _unref(transferType) === 'in' ? 'bg-success' : 'bg-warning'])
                                    }, [
                                        _createVNode(_component_v_icon, { size: "12" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_unref(transferType) === 'in' ? 'south_east' : 'north_west'), 1)
                                            ]),
                                            _: 1
                                        })
                                    ], 2),
                                    _createElementVNode("span", null, _toDisplayString(_unref(transferType) === 'in' ? _ctx.$t('txs.status.recieve') : _ctx.$t('txs.status.sent')), 1)
                                ]),
                                _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(timeAgo)(new Date(props.transfer.transfer.timestamp * 1e3))), 1)
                            ]),
                            _: 1
                        }),
                        (!state.showMoreDetails)
                            ? (_openBlock(), _createBlock(_component_v_col, {
                                key: 0,
                                cols: "6"
                            }, {
                                default: _withCtx(() => [
                                    (!props.metaIsLoading)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(tokenName)), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_7))
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        _createVNode(_component_v_col, { class: "d-flex align-center justify-end" }, {
                            default: _withCtx(() => [
                                (!props.metaIsLoading)
                                    ? (_openBlock(), _createBlock(TokenNftImg, {
                                        key: 0,
                                        loading: props.metaIsLoading,
                                        nft: _unref(tokenMeta),
                                        height: "40",
                                        width: "40"
                                    }, null, 8, ["loading", "nft"]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_8))
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["color"]));
        };
    }
});
